import React, { useEffect, useState } from 'react';
import Modal from '../../components/ui/Modal';
import Btn from '../../components/ui/Btn';
import Badge from '../../components/ui/Badge';
import { Input, Select } from '../../components/ui/Input';
import { empresasApi } from '../../api/admin';
import { COLORS } from '../../theme';

const REGIMES = [
  { value: 'simples_nacional', label: 'Simples Nacional' },
  { value: 'lucro_presumido', label: 'Lucro Presumido' },
  { value: 'lucro_real', label: 'Lucro Real' }
];

const FORM_VAZIO = { nome: '', razao_social: '', cnpj: '', ie: '', uf: '', municipio: '', regime_tributario: 'simples_nacional' };

export default function EmpresasModal({ tenant, onFechar }) {
  const [empresas, setEmpresas] = useState([]);
  const [editandoId, setEditandoId] = useState(null); // null = fechado, 'novo' = criando, id = editando
  const [form, setForm] = useState(FORM_VAZIO);
  const [salvando, setSalvando] = useState(false);

  const carregar = () => empresasApi.listar(tenant.id).then(setEmpresas).catch(() => {});
  useEffect(() => { carregar(); }, [tenant.id]); // eslint-disable-line

  const onChange = (campo, valor) => setForm(f => ({ ...f, [campo]: valor }));

  const abrirNova = () => { setForm(FORM_VAZIO); setEditandoId('novo'); };
  const abrirEdicao = (emp) => {
    setForm({
      nome: emp.nome || '', razao_social: emp.razao_social || '', cnpj: emp.cnpj || '',
      ie: emp.ie || '', uf: emp.uf || '', municipio: emp.municipio || '', regime_tributario: emp.regime_tributario
    });
    setEditandoId(emp.id);
  };

  const salvar = async (e) => {
    e.preventDefault();
    setSalvando(true);
    try {
      if (editandoId === 'novo') {
        await empresasApi.criar({ ...form, tenant_id: tenant.id });
      } else {
        await empresasApi.atualizar(editandoId, form);
      }
      setEditandoId(null);
      carregar();
    } finally {
      setSalvando(false);
    }
  };

  const tornarPadrao = async (id) => {
    await empresasApi.tornarPadrao(id);
    carregar();
  };

  return (
    <Modal titulo={`Empresas (CNPJs) — ${tenant.nome}`} onFechar={onFechar} largura={640}>
      <p style={{ fontSize: 13, color: COLORS.textMid, marginTop: 0 }}>
        Todas as empresas abaixo compartilham o mesmo catálogo de produtos e estoque do grupo "{tenant.nome}".
      </p>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 16 }}>
        {empresas.map(emp => (
          <div key={emp.id} style={{
            display: 'flex', justifyContent: 'space-between', alignItems: 'center',
            border: `1px solid ${COLORS.border}`, borderRadius: 10, padding: '10px 14px'
          }}>
            <div>
              <div style={{ fontWeight: 600, fontSize: 14 }}>{emp.nome} {emp.padrao ? <Badge tom="info">Padrão</Badge> : null}</div>
              <div style={{ fontSize: 12, color: COLORS.textMid }}>{emp.cnpj || 'sem CNPJ'} · {emp.regime_tributario}</div>
            </div>
            <div style={{ display: 'flex', gap: 8 }}>
              <Btn tamanho="sm" variante="ghost" onClick={() => abrirEdicao(emp)}>Editar</Btn>
              {!emp.padrao && <Btn tamanho="sm" variante="ghost" onClick={() => tornarPadrao(emp.id)}>Tornar padrão</Btn>}
            </div>
          </div>
        ))}
        {empresas.length === 0 && <p style={{ color: COLORS.textMid, fontSize: 13 }}>Nenhuma empresa cadastrada.</p>}
      </div>

      {editandoId ? (
        <form onSubmit={salvar} style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, borderTop: `1px solid ${COLORS.border}`, paddingTop: 16 }}>
          <strong style={{ gridColumn: '1 / -1', fontSize: 13 }}>{editandoId === 'novo' ? 'Nova empresa' : 'Editando empresa'}</strong>
          <Input label="Nome Fantasia" value={form.nome} onChange={e => onChange('nome', e.target.value)} required />
          <Input label="Razão Social" value={form.razao_social} onChange={e => onChange('razao_social', e.target.value)} />
          <Input label="CNPJ" value={form.cnpj} onChange={e => onChange('cnpj', e.target.value)} />
          <Input label="Inscrição Estadual" value={form.ie} onChange={e => onChange('ie', e.target.value)} />
          <Input label="UF" value={form.uf} onChange={e => onChange('uf', e.target.value)} maxLength={2} />
          <Input label="Município" value={form.municipio} onChange={e => onChange('municipio', e.target.value)} />
          <Select label="Regime Tributário" options={REGIMES} value={form.regime_tributario} onChange={e => onChange('regime_tributario', e.target.value)} />
          <div style={{ gridColumn: '1 / -1', display: 'flex', gap: 10 }}>
            <Btn variante="ghost" onClick={() => setEditandoId(null)} type="button">Cancelar</Btn>
            <Btn type="submit" disabled={salvando}>{salvando ? 'Salvando...' : 'Salvar Empresa'}</Btn>
          </div>
        </form>
      ) : (
        <Btn variante="secondary" onClick={abrirNova}>+ Nova Empresa (CNPJ)</Btn>
      )}
    </Modal>
  );
}
